import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import { Container, Grid } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router';
import AppButton from 'src/components/common/AppButton';
import AppLoadingAndErrorWrapper from 'src/components/common/AppLoadingAndErrorWrapper';
import { ConfirmDialog } from 'src/components/custom-dialog';
import FormProvider from 'src/components/hook-form';
import useAddNewMatnSection from '../../use-add-new-matn-section';
import AddMatnSectionDetails from '../sections/add-matn-section-details';
import AddSectionDiffWords from '../sections/add-matn-section-diff-words';
import AddMatnSectionSounds from '../sections/add-matn-section-sounds';

const AddNewMatnSection = () => {
  const {
    // Translations
    currentTabValue,
    handleChangeTab,
    allLangs,
    langsWithErrors,
    t,
    // Main form (details & definitions)
    methods,
    onSubmit,
    handleSubmit,
    isUpdatingSec,
    isAddingMatnSection,
    mutateSectionDetails,
    isEditing,
    // Sounds form
    soundForm,
    soundsErrors,
    handleDropSingleFile,
    // Words definitions
    addDiffWords,
    isLoadingWordsDefs,
    deleteWordDefinition,
    isDeletingWord,
    handleAddNewWordDiff,
    handleDeleteWordDiff,
    confirmDeleteWord,
    // Sound variables
    soundDeleteId,
    addSecSounds,
    isLoadingSounds,
    isUploadingSound,
    deleteSound,
    isDeletingSound,
    handleAddNewSound,
    handleDeleteSound,
    confirmDeleteSound,
    // Others
    enqueueSnackbar,
    isLoadingSectionDetails,
    transDeleteId,
    confirm,
  } = useAddNewMatnSection();

  const { matnId } = useParams();

  return (
    <Container>
      <AppLoadingAndErrorWrapper
        isLoading={isLoadingSectionDetails || isLoadingSounds || isLoadingWordsDefs}
        errorMessage={null}
        sx={{ height: 'auto' }}
      >
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Grid container rowSpacing={2}>
            {/* Matn section name and description */}
            <Grid item xs={12}>
              <AddMatnSectionDetails
                t={t}
                handleChangeTab={handleChangeTab}
                langsWithErrors={langsWithErrors}
                currentTabValue={currentTabValue}
              />
            </Grid>
            {/* Matn section difficult words */}

            <Grid item xs={12}>
              <AddSectionDiffWords
                t={t}
                methods={methods}
                allLangs={allLangs}
                addDiffWords={addDiffWords}
                handleAddNewWordDiff={handleAddNewWordDiff}
                handleDeleteWordDiff={handleDeleteWordDiff}
                mutateDelete={deleteWordDefinition}
                confirmDeleteWord={confirmDeleteWord}
                transDeleteId={transDeleteId!}
                isDeletingWord={isDeletingWord}
              />
            </Grid>
            {/* Matn section sounds */}

            <Grid item xs={12}>
              <AddMatnSectionSounds
                t={t}
                soundForm={soundForm}
                soundsErrors={soundsErrors}
                addSecSounds={addSecSounds}
                currentTabValue={currentTabValue}
                handleChangeTab={handleChangeTab}
                handleAddNewSound={handleAddNewSound}
                handleDeleteSound={handleDeleteSound}
                handleDropSingleFile={handleDropSingleFile}
                mutateDelete={deleteSound}
                deleteSoundId={soundDeleteId!}
                confirmDeleteSound={confirmDeleteSound}
                isDeletingSound={isDeletingSound}
                isUploadingSound={isUploadingSound}
              />
            </Grid>
            <Grid item xs={12}>
              <AppButton
                label={
                  isEditing ? t('buttons.editMatnSectionAndAddNewWordsAndSounds') : t('buttons.add')
                }
                isLoading={isAddingMatnSection || isUpdatingSec || isUploadingSound}
                type="submit"
                fullWidth
              />
            </Grid>
          </Grid>
        </FormProvider>
      </AppLoadingAndErrorWrapper>
      {/* Confirm */}
      <ConfirmDialog
        open={confirm.value}
        onClose={(event: React.SyntheticEvent<Element, Event>, reason: string) => {
          if (reason && reason === 'backdropClick') {
            confirm.onFalse();
          }
        }}
        content={t('dialogs.confirmMessage', {
          editOrAdd: isEditing ? t('buttons.edit').toLowerCase() : t('buttons.add').toLowerCase(),
        })}
        icon={<BorderColorOutlinedIcon fontSize="large" sx={{ mx: 'auto' }} />}
        action={
          <>
            <AppButton
              fullWidth
              label={t('publicWords.no')}
              variant="outlined"
              onClick={() => {
                confirm.onFalse();
              }}
            />
            <AppButton
              fullWidth
              label={t('publicWords.yes')}
              isLoading={isAddingMatnSection || isUpdatingSec || isUploadingSound}
              onClick={mutateSectionDetails}
            />
          </>
        }
      />
    </Container>
  );
};

export default AddNewMatnSection;
